import { render } from "./Employee.vue?vue&type=template&id=1d4c99ac&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"

import "./Employee.vue?vue&type=style&index=0&id=1d4c99ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4c99ac"]])

export default __exports__